<template>
    <div class="container section-holder mycourse-cards">
        <div class="pb-3 row justify-content-end">
            <h6 class="col-md-12 main-title">{{$t('common.labels.Courses')}}</h6>
        </div>
        <div v-if="$store.getters.getItemsEnrolledByType('CO') != undefined && $store.getters.getItemsEnrolledByType('CO') != null && $store.getters.getItemsEnrolledByType('CO').length !=0" class="row">
            <div v-for="(course,index) in $store.getters.getItemsEnrolledByType('CO')" :key="index" class="col-sm-6 col-md-5 col-lg-4 col-xl-3">
                <div class="card-design">
                    <!-- <div v-if="checkValue(course.thumbnail)" style="background-image: "makePath(course.thumbnail)"></div> -->
                    <div v-if="course.thumbnail.length !== 0" class="card-design__img" >
                      <img :src="makePath(course.thumbnail)" alt="">
                    </div>
                    <div v-else class="card-design__img">
                      <img src="../../../static/assets/images/defaultCO.jpg" alt="">
                    </div>
                    <div class="card-design__data">
                     <router-link   v-if="instanceName !== 'MAHADEMY'" tag="h3" v-b-tooltip.hover :title="course.title" class="card-design__data-heading text-truncate" :to="{ name: 'coursePage', params: { contentId: course.contentId }}">{{course.title}}</router-link>
                      <h3  v-if="instanceName === 'MAHADEMY'" class="card-design__data-heading no-line text-truncate" v-b-tooltip.hover :title="course.title">{{course.title}}</h3>

                      <!-- <h3 class="card-design__data-heading" @click="viewCourse(course)">{{course.title}}</h3> -->
                      <!-- <span class="course-text">{{$t('myCourses.labels.LearnAbout')}}</span> -->
                      <!-- <div class="progress-css">
                          <strong>22.5 hours</strong> {{$t('myCourses.labels.RemainingMsg')}}
                          <b-progress height="2px" :value="78"></b-progress>
                      </div> -->
                      <p class="card-design__data-cost" v-if="instanceName !== 'MAHADEMY'">{{course.price}} {{course.price > 1 ? 'Points' : 'Point'}}</p>
                      <div class="ratingText" v-if="instanceName !== 'MAHADEMY'">{{$t('course.my_rating')}}</div>
                      <div v-if="parseInt(course.rating) == 0 && instanceName !== 'MAHADEMY'" class="card-design__data-ratings">
                         <star-rating :rating="parseInt(course.rating)" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                        </star-rating> 
                      </div> 
                      <div v-else-if="instanceName !== 'MAHADEMY'" class="card-design__data-ratings" >
                         <star-rating :rating="course.rating" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                        </star-rating>
                      </div>
                      <!-- share widgets -->
                      <share-on-media :item="course" :labelOnTop="true"></share-on-media> 
                      <div class="row box-action">
                        <div class="col">
                          <button class="btn btn-green-o" @click="goToCourse(course)">{{$t('common.labels.GO_TO_COURSE')}}</button>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="noticemsg-alt">
          <span>{{$t('myCourses.labels.NoCourses')}}</span>
        </div>
    </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import * as constants from '@/components/common/constants.js'
import ShareOnMedia from '../common/shareOnMedia'
import axios from 'axios'
export default {
  name: 'courseCards',
  components: {
    StarRating, ShareOnMedia
  },
  data () {
    return {
      instanceName: constants.INSTANCE_NAME,
      profileId: this.$store.getters.getProfileDetails.profileId,
      coList: [],
      loList: []
    }
  },
  methods: {
    viewCourse (course) {
      if (this.isLoggedIn) {
        return new Promise((resolve, reject) => {
          axios.post('r/viewEnrolledItem', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': course.contentId })
            .then(response => {
              // alert('response:' + JSON.stringify(response.data))
              this.$store.dispatch('setCurrentCourse', response.data)
              resolve()
            })
            .catch(err => {
              console.log('ERROR_IN_myCourseCard : ', err)
              reject()
            })
        })
      }
      this.$store.dispatch('getCourseDetails', course.contentId)
      this.$router.push({ path: '/coursePage' })
    },
    // checkValue (val) {
    //   if (val.length === 0) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    makePath (path) {
      // var url = constants.CDP_CDN_THUMBNAIL_URL
      return constants.CDP_CDN_THUMBNAIL_URL + '/' + path
      // return url + path
    },
    goToCourse (course) {
      this.$store.dispatch('checkExpiryDateForCO', course)
    }
  },
  mounted () {
    this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId).then(res => {}
    , err => {
      console.log('ERROR_IN_FETCHING_ENROLLING_ITEM : ', err)
    })
  }
  // created () {
  //   this.$store.dispatch('fetchEnrolledCourses', this.profileId)
  //   this.loList = this.$store.getters.getCourseEnrolled
  //   this.loList.forEach(element => {
  //     if (element.courseType === 'CO') {
  //       this.coList.push(element)
  //     }
  //   })
  //   this.$store.commit('setCourseCOEnrolled', this.coList)
  // }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.mycourse-cards {
  .card-course {
    border-radius: 3px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin-bottom: 36px;
    .card-content {
      padding: 20px;
      .course-name {
        text-decoration: none;
        font-weight: bold;
        font-size: 13px;
        line-height: 18px;
        padding-top: 5px;
        font-family: $opensans;
      }
      .course-text {
        font-size: 12px;
        color: #666;
      }
      .course-cost {
        font-size: 24px;
        color: #52b3e7;
      }
      .progress-css {
        padding-top: 10px;
        font-size: 12px;
      }
      .rating-ptag {
        padding-top: 20px;
        font-size: 12px;
        color: #666;
        .rating-star {
          padding-left: 10px;
          .fa-star {
            color: #96999a;
            &:hover {
              color: #ffc000;
            }
          }
          .active {
            color: #ffc000;
          }
        }
      }
    }
    .img-fluid {
      height: 192px;
      background: no-repeat center center / cover;
      border-top-right-radius: 3px;
      border-top-left-radius: 3px;
      position: relative;
    }
    &:hover {
      cursor: pointer;
      transition: box-shadow 0.45s;
      box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.25);
      .course-name {
        text-decoration: underline;
      }
      .btn-blue-outline {
        background: linear-gradient(to right, #67c8fb 0%, #63bdef 100%);
        color: #fff;
        &:hover {
          background: linear-gradient(to right, #55bef7 0%, #42b1ec 100%);
        }
      }
    }
  }
  @media (max-width: 576px) {
  .main-title {text-align:center;}
  }
  @media (min-width: 577px) {
    .main-title {text-align:left;}
  } 
}

</style>



// WEBPACK FOOTER //
// src/components/myCourses/mycourseCards.vue?62a4b4ec